import * as React from 'react';
import { IconFactory } from '../IconFactory/IconFactory';
import { IConfigObj } from '@makemydeal/dr-common-utils';
import { MessageBoxContainer } from './StyledMessageBox';

export interface IMessageBoxProps {
    staticImages: IConfigObj;
    clickClose?: () => any;
    header?: string;
    message: string;
}

const renderHeader = (header) => {
    return header ? (
        <>
            <span style={{ fontWeight: 700 }}>{header}</span>:{' '}
        </>
    ) : null;
};

const renderCloseButton = (clickClose, staticImages) => {
    if (clickClose) {
        return (
            <div className="close-x" onClick={clickClose}>
                <IconFactory staticImages={staticImages} icon="closeX" />
            </div>
        );
    } else {
        return null;
    }
};

export const MessageBox: React.FC<IMessageBoxProps> = (props: IMessageBoxProps) => {
    const { staticImages, clickClose, header, message } = props;

    return (
        <MessageBoxContainer>
            <div className="message-box-outer-container">
                <div className="message-box-inner-container">
                    <div className="chat-bubbles">
                        <IconFactory staticImages={staticImages} icon="chatBubbles" />
                    </div>
                    <div data-testid="message-box-message">
                        {renderHeader(header)}
                        {message}
                    </div>
                    {renderCloseButton(clickClose, staticImages)}
                </div>
            </div>
        </MessageBoxContainer>
    );
};
